export default __webpack_public_path__ + "static/media/icon07.3aa81b33.png";